export const API_BASE_URL =
  (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:7564';

// Build-time environment tag — set by the production deploy workflow
// (see deploy.yml (admin job)). Used to surface a visible banner so the user
// can't accidentally treat a local dev instance as production.
// Anything other than 'production' is treated as non-prod and the banner shows.
export const ENVIRONMENT =
  ((import.meta.env.VITE_ENVIRONMENT as string | undefined) ?? 'development') as
    | 'development'
    | 'production';

export const IS_NON_PROD = ENVIRONMENT !== 'production';
